export function LoadingScreen() {
  return (
    <div role="status" aria-live="polite" className="text-sm text-slate-500">
      Loading…
    </div>
  )
}
